<template>
  <div class="flex items-center justify-center h-14 w-14 text-white rounded-lg shrink-0 transition-all snap-center"
       :class="active ? 'bg-yellow-500 transform scale-125' : 'bg-gray-900'"
       @click="$emit('monthClicked', month)" ref="month">
    <div class="text-center">
      <p class="font-bold text-lg">{{ renderMonth }}</p>
      <p class="text-xs">{{ renderMonthName }}</p>
    </div>
  </div>
</template>

<script>
import jDate from "jalali-date"

export default {
  name: "MonthViewer",
  emits: ['monthClicked'],
  props: ['month', 'active'],
  computed: {
    renderMonth() {
      if (this.month < 10) {
        return "0" + this.month
      }

      return this.month
    },
    renderMonthName() {
      let date = new jDate();
      date.setMonth(this.month)
      return date.format("MMM")
    }
  },
  mounted() {
    if (this.active) {
      this.$refs.month.scrollIntoView({
        inline: "center"
      })
    }
  }
}
</script>

<style scoped>

</style>